import { Siren } from 'lucide-react'

import { Button } from '@krp/ui-kit'

import type { FeedbackHelpVm } from '../model/types'

/**
 * «Что это значит» под отказом службы (текст отказа — дословно в баннере над
 * ним): объяснение словами и, если исход операции продажи неизвестен, — путь в
 * «Инциденты продаж». Один вид на всех этапах РМК: выбор кассы, порог смены,
 * «Действия».
 */
export function FeedbackHelp({ help, onIncidents }: { help: FeedbackHelpVm | null; onIncidents: () => void }) {
  if (help === null) return null
  return (
    <div className="aqsi-panel" role="note" aria-label="Что это значит">
      <p className="aqsi-card__text">{help.text}</p>
      {help.incidents && (
        <div className="aqsi-card__actions">
          <Button icon={<Siren size={14} aria-hidden="true" />} onClick={onIncidents}>
            Открыть «Инциденты продаж»
          </Button>
        </div>
      )}
    </div>
  )
}
